import { FeatureCanActivate } from '@ecap3/core';
import { Unauthorized } from './unauthorized/unauthorized.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { Routes } from "@angular/router";

export const authFailedRedirection: any = [
    {
        role: 'admin',
        loggedInredirectTo: '/home',
        loggedOutredirectTo: '/login'
    },
    {
        role: 'hr_member',
        loggedInredirectTo: '/home',
        loggedOutredirectTo: '/login'
    },
    {
        role: 'delta_employee',
        loggedInredirectTo: '/home',
        loggedOutredirectTo: '/login'
    },
    {
        role: 'appuser',
        loggedInredirectTo: '/home',
        loggedOutredirectTo: '/login'
    },
    {
        role: 'delta_planner',
        loggedInredirectTo: '/home',
        loggedOutredirectTo: '/login'
    }
];

export const routes: Routes = [
    {
        path: 'iam',
        loadChildren: () =>
            import('../infrastructure/app-uam/app-uam.module').then(
                (m) => m.AppUamModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'uam',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
        data: {
            isFullScreen: true,
            requiredFeature: 'login'
        }
    },
    {
        path: 'login',
        loadChildren: () =>
            import('../infrastructure/app-login/app-login.module').then(
                (m) => m.AppLoginModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: true,
            requiredFeature: 'login',
            authFailRedirection: authFailedRedirection,
            isPublic: true
        }
    },
    {
        path: 'arc-home',
        loadChildren: () =>
            import('../business/app-landing/app-landing.module').then(
                (m) => m.AppLandingModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: true,
            requiredFeature: 'app-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: true
        }
    },
    {
        path: '',
        loadChildren: () =>
            import('../business/app-landing/app-landing.module').then(
                (m) => m.AppLandingModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'app-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.APP_LANDING_TITLE',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'usercreate',
        loadChildren: () =>
            import('../infrastructure/app-uam/app-uam.module').then(
                (m) => m.AppUamModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'arc-uam-manager',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'UAM',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'uilm',
        loadChildren: () =>
            import('../infrastructure/uilm-tool/uilm-tool.module').then(
                (m) => m.AppUilmModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'arc-language-manager',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'home',
        loadChildren: () =>
            import('../business/app-landing/app-landing.module').then(
                (m) => m.AppLandingModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'profile',
        loadChildren: () =>
            import('../business/app-profile-v2/app-profile-v2.module').then(
                (m) => m.AppProfileV2Module
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'open-position',
        loadChildren: () =>
            import(
                '../business/app-open-positions/app-open-positions.module'
            ).then((m) => m.AppOpenPositionsModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'projects-wishlist',
        loadChildren: () =>
            import(
                '../business/app-projects-wishlist/app-projects-wishlist.module'
            ).then((m) => m.AppProjectsWishlistModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'attendance-history',
        loadChildren: () =>
            import(
                '../business/app-attendance-history/app-attendance-history.module'
            ).then((m) => m.AppAttendanceHistoryModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'ATTENDANCE_HISTORY',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'income-and-hours',
        loadChildren: () =>
            import(
                '../business/app-income-and-hours/app-income-and-hours.module'
            ).then((m) => m.AppIncomeAndHoursModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'INCOME_AND_HOURS',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'quality-reports',
        loadChildren: () =>
            import(
                '../business/app-quality-reports/app-quality-reports.module'
                ).then((m) => m.AppQualityReportsModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'QUALITY_REPORTS',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'onsite-reports',
        loadChildren: () =>
            import(
                '../business/app-onsite-reports/app-onsite-reports.module'
            ).then((m) => m.AppOnsiteReportsModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'announcement',
        loadChildren: () =>
            import(
                '../business/app-announcements/app-announcements.module'
            ).then((m) => m.AppAnnouncementsModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'academy',
        loadChildren: () =>
            import('../business/app-academy/app-academy.module').then(
                (m) => m.AppAcademyModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },

    // {
    //     path: 'notifications',
    //     loadChildren: () =>
    //         import('../business/app-notification/app-notiication.module').then(
    //             (m) => m.AppNotificationModule
    //         ),
    //     canActivate: [FeatureCanActivate],
    //     data: {
    //         isFullScreen: false,
    //         requiredFeature: 'ma-landing',
    //         authFailRedirection: authFailedRedirection,
    //         isPublic: false,
    //         breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
    //         isTranslate: true,
    //         isHide: false,
    //         breadcrumbType: 'link'
    //     }
    // },

    {
        path: 'chats',
        loadChildren: () =>
            import('../business/app-chat/app-chat.module').then(
                (m) => m.AppChatModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },

    {
        path: 'schedule',
        loadChildren: () =>
            import('../business/app-schedule/app-schedule.module').then(
                (m) => m.AppScheduleModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'my-documents',
        loadChildren: () =>
            import('../business/app-my-documents/my-documents.module').then(
                (m) => m.AppMyDocumentsModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'DMS-Common-Feature',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.MY_DOCUMENTS',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'organizational-documents',
        loadChildren: () =>
            import('../business/app-organizational-documents/organizational-documents.module').then(
                (m) => m.AppOrganizationalDocumentsModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'DMS-Common-Feature',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.ORGANIZATIONAL_DOCUMENTS',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'inventory',
        loadChildren: () =>
            import('../business/app-inventory/app-inventory.module').then(
                (m) => m.AppInventoryModule
            ),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'ma-landing',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            // breadcrumb: 'BREADCRUMB.LANGUAGE_MANAGER',
            isTranslate: true,
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'recaptcha',
        loadComponent: () =>
            import('./recaptcha/recaptcha.component').then(
                (m) => m.RecaptchaComponent
            ),
        data: {
            isFullScreen: true,
            isPublic: true
        }
    },
    {
        path: '401',
        component: Unauthorized,
        data: {
            isFullScreen: false,
            isPublic: false
        }
    },
    {
        path: '404',
        component: NotFoundComponent,
        data: {
            isFullScreen: false,
            isPublic: false
        }
    },
    {
        path: '**',
        redirectTo: '/404',
        data: {
            isFullScreen: false,
            isPublic: false
        }
    }
];
